<div
  class="number-step-input-container flex flex-row align-items-center justify-content-center"
  data-cy="number-step-input"
>
  <button
    pButton
    type="button"
    icon="mi-round mi-remove-circle-outline"
    aria-label="Decrease"
    class="p-button-text"
    (click)="onDecrement()"
    [disabled]="control.disabled || control.value === 0"
    data-cy="decrement-button"
    appClickEvent
    eventName="number_step_input_decrement_amount"
  ></button>
  <input
    pInputText
    id="{{ name }}"
    type="text"
    readonly="true"
    [attr.inputmode]="'numeric'"
    [formControl]="control"
    class="mx-3"
    [attr.data-cy]="name"
    [attr.aria-label]="name"
  />
  <button
    pButton
    type="button"
    icon="mi-round mi-add-circle-outline"
    aria-label="Increase"
    class="p-button-text"
    (click)="onIncrement()"
    [disabled]="control.disabled"
    data-cy="increment-button"
    appClickEvent
    eventName="number_step_input_increment_amount"
  ></button>
</div>
